
import { commonfunc } from '~/mixin/common'
import CommonImage from '~/components/common/CommonImage.vue'

export default {
  name: 'ProdEmblem',
  components: { CommonImage },
  mixins: [commonfunc],
  props: {
    imgUrl: {
      type: String,
      default: ''
    },
    emblemName: {
      type: String,
      default: ''
    }
  },
}
